import React from 'react';
import './Auth.scss';
//#region COMPONENTS
import { Navigate, Route, Routes } from 'react-router-dom';
import ForgotPassword from '../Auth/ForgotPassword/ForgotPassword';
import LogIn from '../Auth/Login/LogIn';
import ResetPassword from '../Auth/ResetPassword/ResetPassword';
//#endregion
//ICONS
import Banner from '../../../assets/images/banner.png';
import OwnerLogoLight from "../../../assets/images/owner_logo_light.png";

const Auth = () =>
    <div id="Auth" className={"default"} >
        <div className="container">
            <div className="mainLogo mb-4">
                <img src={OwnerLogoLight} alt="Aquanexa" loading='lazy' />
            </div>

            <div className='pages'>
                <img src={Banner} alt="Aquanexa" loading='lazy' width={350} />
                <Routes>
                    <Route path="/" element={<LogIn /*login = {props.login}*/ />} />
                    <Route path="/forgotPassword" element={<ForgotPassword />} />
                    <Route path="/ResetPassword/:username/:otp" element={<ResetPassword />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </div>
        </div>
    </div >;
export default React.memo(Auth);